import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { isSameOrAfter, isSameOrBefore } from '@fora-monorepo/date-utils';
import { ValidationResult, ValidationRule } from '@foradevelopment/fora-ui';

export const isMarkupStartDateWithinAnyFOKValidityPeriod =
  (errorMessage: string, faGroups: FAGroupViewModel[]): ValidationRule =>
  (value: string): ValidationResult => {
    const isValid = faGroups.some(
      faGroup => isSameOrAfter(value, faGroup.validFrom) && (!faGroup.validTo || isSameOrBefore(value, faGroup.validTo))
    );
    return { error: !isValid, errorMessage };
  };
